module.exports = __webpack_public_path__ + "img/btn_income_red.a1cdbd60.svg";